const styles = theme => ({
  visible: {
    visibility: 'visible',
    backgroundColor: '#015FFB',
    color: '#fff',
    borderRadius: 24,
    textTransform: 'none',
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: '13px',
    padding: '8px 16px',
    minWidth: 100,
    '&:hover': {
      backgroundColor: '#0150D8',
    },
    '&.Mui-disabled': {
      backgroundColor: '#E5E7EB',
      color: '#9CA3AF',
    },
  },
  hidden: {
    visibility: 'hidden',
  },
  cellWide: {
    width: '40%',
    backgroundColor: '#fff',
    borderBottom: 'none',
  },
  customButtonStyle: {
    borderColor: '#002E47',
    color: '#002E47',
    borderRadius: 24,
    textTransform: 'none',
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: '13px',
    padding: '8px 16px',
    minWidth: 100,
    '&:hover': {
      borderColor: '#002E47',
      backgroundColor: 'rgba(0, 46, 71, 0.04)',
    },
  },
})

export default styles
